import { styled } from '@mui/material/styles';
import { Button, Typography } from '@mui/material';
import { IconPencil } from '@tabler/icons-react';
import { Visibility, Edit } from '@mui/icons-material';
import {t} from "i18next";

export const SubmitButton = styled(Button)(({ theme }) => ({
    color: '#FFF',
    minWidth: 200,
    backgroundColor: '#0A579B',
    borderRadius: 4,
    ':hover': {
        backgroundColor: theme.palette.primary.main,
        color: '#FFF'
    }
}));

export const SelectionButton = styled(SubmitButton, {
    shouldForwardProp: (prop) => prop !== 'selected'
})(({ theme, selected }) => ({
    color: selected ? theme.palette.primary : '#0A579B',
    backgroundColor: selected ? '#0A579B' : '#FFF',
    border: `2px solid ${selected ? '#0A579B' : '#CFD8DC'}`,
    ':hover': {
        border: `2px solid ${theme.palette.primary.main}`
    }
}));

SelectionButton.defaultProps = {
    variant: 'outlined'
};

export const AlertSelectionButton = styled(SubmitButton, {
    shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'colorType'
})(({ selected, colorType }) => {
    const activeColor = '#f84848';
    const activeHover = '#f84848';
    const finishedColor = '#1976d2';
    const finishedHover = '#4791db';

    const baseColor = colorType === 'finished' ? finishedColor : activeColor;
    const hoverColor = colorType === 'finished' ? finishedHover : activeHover;

    return {
        color: selected ? '#fff' : baseColor,
        backgroundColor: selected ? baseColor : '#fff',
        border: `2px solid ${selected ? baseColor : '#CFD8DC'}`,
        ':hover': {
            backgroundColor: selected ? hoverColor : '#f5f5f5',
            border: `2px solid ${hoverColor}`,
            color: selected ? '#fff' : hoverColor
        }
    };
});

AlertSelectionButton.defaultProps = {
    variant: 'outlined'
};

export const GroupSelectionButton = styled(SubmitButton, {
    shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'colorType'
})(({ selected, colorType }) => {
    const activeColor = '#1976d2';
    const activeHover = '#4791db';
    const finishedColor = '#388e3c';
    const finishedHover = '#66bb6a';

    const baseColor = colorType === 'finished' ? finishedColor : activeColor;
    const hoverColor = colorType === 'finished' ? finishedHover : activeHover;

    return {
        color: selected ? '#fff' : baseColor,
        backgroundColor: selected ? baseColor : '#fff',
        border: `2px solid ${selected ? baseColor : '#CFD8DC'}`,
        ':hover': {
            backgroundColor: selected ? hoverColor : '#f5f5f5',
            border: `2px solid ${hoverColor}`,
            color: selected ? '#fff' : hoverColor
        }
    };
});

GroupSelectionButton.defaultProps = {
    variant: 'outlined'
};

export const EditButton = styled(Button)(({ theme }) => ({
    borderRadius: 25,
    borderColor: '#CFD8DC',
    '& .MuiSvgIcon-root': {
        color: '#0A579B'
    }
}));

EditButton.defaultProps = {
    variant: 'outlined',
    startIcon: <Edit />
};

export const SeeButton = styled(Button)(({ theme }) => ({
    borderRadius: 25,
    borderColor: '#CFD8DC',
    '& .MuiSvgIcon-root': {
        color: '#0A579B'
    }
}));

SeeButton.defaultProps = {
    variant: 'outlined',
    startIcon: <Visibility />
};
